<template>
    <div class="goods">
        <Header ref="header"  @backPage="onBack" :title="title"></Header>
        <div class="contract">
            <img src="../../../assets/img/b2b/img_ooops@2x.png" width="140" height="140" alt="">
            <p>未找到该页面信息</p>
        </div>
    </div>
</template>
<script>
import Header from '../../common/header'
export default {
    name: 'allGoods',
    components: {
        Header
    },
    data () {
        return {
            goodsDetailBack: '',
            height: 0,
            title: '页面出错'
        }
    },
    methods: {
        onBack () {
            this.$router.go(-1)
        }
    },
    mounted () {
    }
}
</script>
<style lang="scss" scoped>
    .goods{
        height: 100%;
        font-size: 28px;
        overflow: hidden;
        .contract{
            width: 400px;
            margin: 0 auto;
            margin-top: 320px;
            text-align: center;
            p{
                color: #999999;
            }
        }
    }
    .is-android-top{
        top: 88px;
    }
    .is-ios-top{
        top: 128px;
    }
    .is-ios2-top{
        top: 176px;
    }
</style>